import { PlanType } from 'src/app/core/enums/user';
import { UserProfile } from 'src/app/core/models/user';
import { HttpErrorResponse } from '@angular/common/http';
import { Logger, MasterHelper } from 'src/app/core/utilities';
import { Role } from 'src/app/core/models/user-management/role';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { RegulationFilterModel } from 'src/app/core/models/regulation';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { UserItemModel } from 'src/app/core/models/user/user-item-model';
import { SessionService } from 'src/app/core/services/auth/session.service';
import { ItemIdModel } from 'src/app/core/models/filter-model/item-id-model';
import { DataModel } from './../../../core/models/user-management/data-model';
import { RegulatorMaster } from 'src/app/core/models/regulation/regulator-master';
import { FilterItems } from './../../../core/models/user-management/filter-items';
import { UserRegulatorDto } from './../../../core/models/user/user-regulator-dto';
import { UserInfoData } from 'src/app/core/models/user-management/user-info-data';
import { AlertDialogModel } from '../../../core/models/view-model/alert-dialog.model';
import { AssignedRoleDto } from 'src/app/core/models/user-management/assigned-role-model';
import { UserLicensedModel } from 'src/app/core/models/user-management/user-licensed-model';
import { UserInfoFilterModel } from 'src/app/core/models/user-management/user-filter-model';
import { UserManagementService } from 'src/app/core/services/user-management/user-management.service';
import { UserRegulatorDialogComponent } from '../user-regulator-dialog/user-regulator-dialog.component';
import { DeleteDialogComponent } from './../../distributed-ui-components/delete-dialog/delete-dialog.component';
import { ToastViewModel } from 'src/app/core/models/view-model';
import { MatDialog } from '@angular/material/dialog';
import { GeneralDataService } from 'src/app/core/services/general/general-data.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-user-manager',
  templateUrl: './user-manager.component.html',
  styleUrls: ['./user-manager.component.scss']
})
export class UserManagerComponent implements OnInit {
  @ViewChild(CdkVirtualScrollViewport)
  viewport!: CdkVirtualScrollViewport;
  @ViewChild('tableContent', { read: ElementRef })
  public tableContent: any;
  myInnerHeight: any;

  userRoleList: Array<Role>;
  jurisdictionList: Array<ItemIdModel>;
  userList: Array<AssignedRoleDto>;
  isLoading = false;
  startIndex = 0;
  lastIndex = 0;
  currentPageNumber = 1;
  totalPageCount = 0;
  totalCount = 0;
  takeCount = 0;
  skipCount = 0;
  filters: FilterItems;
  isTableLoaded = false;
  searchText: string;
  regulatorsDto: UserRegulatorDto;
  userRegulatorResult: UserItemModel;
  alertDialogModel: AlertDialogModel;
  userInfoObj: AssignedRoleDto;
  userScreen: Array<DataModel>;
  regulatorUserId: number;
  loggedInUser: UserProfile;
  endIndex = 0;
  licensedData: UserLicensedModel;
  selectedJuris: ItemIdModel[] = [];
  filterPersistenceKey = 'regulationFilter';
  isUserIdExist = false;
  toastModel: ToastViewModel;
  isToastShow = false;
  isUserId = false;
  isShowDivisionUser = true;
  selectedDivisionName: any;

  constructor(private userManagementService: UserManagementService, public dialog: MatDialog, private sessionService: SessionService, private generalService: GeneralDataService) {
    this.userRoleList = [];
    this.userList = [];
    this.searchText = '';
    this.filters = new FilterItems();
    this.regulatorsDto = new UserRegulatorDto();
    this.userRegulatorResult = new UserItemModel();
    this.alertDialogModel = new AlertDialogModel();
    this.userInfoObj = new AssignedRoleDto();
    this.userScreen = [];
    this.regulatorUserId = 0;
    this.loggedInUser = new UserProfile();
    this.filters.IsDesc = false;
    this.filters.SortKey = 'FullName';
    this.myInnerHeight = window.innerHeight - 220;
    this.licensedData = new UserLicensedModel();
    this.jurisdictionList = [];
    this.toastModel = new ToastViewModel();
  }

  ngOnInit() {
    this.loginUserInfo();
    this.fetchJurisdictions();
    this.showDivisionWiseUser();
    this.fetchLicensedDetails();
    this.fetchUserRoles();

    // this.fetchAllUsers();
    this.fetchRegulators();
    this.generalService.getDivisionSelected().subscribe(async res => {
      this.isShowDivisionUser = true;
      this.showDivisionWiseUser();
    });
  }

  fetchFromBrowser(key: string): any {
    return localStorage.getItem(key);
  }

  eventHandler(): void {
    this.endIndex = this.viewport.getRenderedRange().end;
  }

  loginUserInfo(): void {
    this.sessionService.getLoginUserInfo().subscribe((user: UserProfile) => {
      this.loggedInUser = user;
    });
  }

  fetchLicensedDetails(): void {
    this.userManagementService.getLicensedDetails().subscribe((result: UserLicensedModel) => {
      this.licensedData = result;
    });
  }

  fetchUserRoles(): void {
    this.userManagementService.getRoles().subscribe((userRoles: Role[]) => {
      this.userRoleList = userRoles;
    });
  }

  fetchJurisdictions(): void {
    this.userManagementService.getAllJurisdictions().subscribe((result: ItemIdModel[]) => {
      this.jurisdictionList = result;
    });
  }

  fetchAllUsers(): void {
    this.userList = [];
    this.totalCount = 0;
    this.isLoading = true;
    this.filters.Skip = this.skipCount;
    this.filters.Take = this.takeCount;
    this.filters.SearchText = this.searchText;
    const filterItems = new UserInfoFilterModel();
    filterItems.division = this.selectedJuris.length > 0 ? MasterHelper.getStringArrayFromObjectArray(this.selectedJuris) : [];
    filterItems.filters = this.filters;
    this.userManagementService.getAllUsers(filterItems).subscribe((data: UserInfoData) => {
      this.isLoading = false;
      if (data.userList && data.userList.length > 0) {
        // Amit Madahar Login Permission
        if (this.loggedInUser.emailId !== 'amit.madahar@finreg-e.com') {
          for (let i = 0; i < data.userList.length; i++) {
            if (data.userList[i].emailId === 'amit.madahar@finreg-e.com') {
              data.userList.splice(i, 1);
            }
          }
        }
        this.userList = data.userList;
        // Amit Madahar Login Permission
        if (this.loggedInUser.emailId !== 'amit.madahar@finreg-e.com') {
          for (let i = 0; i < this.userList.length; i++) {
            if (this.userList[i].emailId === 'amit.madahar@finreg-e.com') {
              this.userList.splice(i, 1);
              data.totalCount = data.totalCount - 1;
            }
          }
        }
        this.totalCount = this.userList.length;
        this.isTableLoaded = true;
        this.CalculatePageCount(this.totalCount, this.takeCount);
        this.lastIndex = this.skipCount + this.userList.length;
        this.startIndex = (this.takeCount * (this.currentPageNumber - 1)) + 1;
        this.endIndex = this.endIndex > this.totalCount ? this.totalCount : this.endIndex;
      }
    });
  }

  sortUsers(key: string): void {
    this.filters.IsDesc = !this.filters.IsDesc;
    this.filters.SortKey = key;
    if (this.isShowDivisionUser) {
      this.isShowDivisionUser = false;
      this.fetchAllUsers();

    }
    else {
      this.showDivisionWiseUser();
    }
  }

  updateUserDetails(userinfo: AssignedRoleDto): void {
    this.isLoading = true;
    userinfo.roleId = +userinfo.roleId;
    userinfo.planType = +userinfo.planType;
    userinfo.landingPage = +userinfo.landingPage;
    userinfo.isActive = String(userinfo.isActive) === 'true' ? true : false;
    this.userManagementService.updateUserInfo(userinfo).subscribe((result: any) => {
      let screenUrl = result.data;
      this.isLoading = false;
      if (userinfo.userId === this.loggedInUser.userId) {
        this.userList.forEach(element => {
          if (element.userId === userinfo.userId) {
            const screenInfo = element.userScreenList.find(a => +a.id === +userinfo.landingPage);
            screenUrl = screenInfo ? screenInfo.screenUrl : '/change-viewer';
          }
        });
        this.SaveRoleScreen(userinfo.roleId, screenUrl, userinfo.planType);
      } else {
        window.location.reload();
      }
    }, (result) => {
      this.isLoading = false;
      if (result.error.match('User Id Already Exist')) {
        this.isUserId = true;
        this.isToastShow = true;
        this.alertMessage("warning", "User Id Already Exist");
      }
    });
  }

  SaveRoleScreen(newRoleId: number, landingPage: string, planType: PlanType): void {
    this.loggedInUser.roleId = newRoleId;
    this.loggedInUser.planType = planType;
    if (landingPage) {
      this.loggedInUser.landingPage = landingPage;
    }
    window.location.reload();
  }

  OnAction(currentPageNumber: number): void {
    this.currentPageNumber = currentPageNumber;
    this.skipCount = this.takeCount * (currentPageNumber - 1);
    this.fetchAllUsers();
  }

  CalculatePageCount(totalItems: number, takeCount: number): void {
    this.totalPageCount = parseInt((totalItems / takeCount).toString(), 10);
    if (totalItems % takeCount !== 0 && totalItems > 10) {
      this.totalPageCount = this.totalPageCount + 1;
    }
  }

  searchUser(): void {
    if (this.isShowDivisionUser) {
      this.fetchAllUsers();
    }
    else {
      this.isShowDivisionUser = true;
      this.showDivisionWiseUser();
    }
  }

  onEnterKeySearchUser(event: any): void {
    if (event.keyCode === 13) {
      if (this.isShowDivisionUser) {
        this.fetchAllUsers();
      }
      else {
        this.isShowDivisionUser = true;
        this.showDivisionWiseUser();
      }
    }
  }

  fetchRegulators(): void {
    this.userManagementService.getRegulators().subscribe((data: RegulatorMaster[]) => {
      this.regulatorsDto.regulators = data;
    });
  }

  openDialog(userId: number, fullname:string): void {
    this.regulatorUserId = userId;
    this.regulatorsDto.userId = userId;
    const dialogRef = this.dialog.open(UserRegulatorDialogComponent, {
      width: '550px',
      data: this.regulatorsDto
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result && result.filter === 'Regulator') {
        this.updateUserRegulator(result.itemArray);
      } else if (result) {
        this.updateUserJurisdiction(result.itemArray, fullname);
      }
    });
  }

  updateUserRegulator(result: Array<number>): void {
    this.userRegulatorResult.userId = this.regulatorUserId;
    this.userRegulatorResult.itemIds = result;
    this.userManagementService.updateUserRegulators(this.userRegulatorResult).subscribe(() => {
      location.reload();
    });
  }

  updateUserJurisdiction(result: Array<number>, fullName:string): void {
    this.userRegulatorResult.userId = this.regulatorUserId;
    this.userRegulatorResult.itemIds = result;
    this.userRegulatorResult.username = fullName;
    this.setDivision(result[0]);
    this.userManagementService.updateUserJurisdictions(this.userRegulatorResult).subscribe(() => {
      location.reload();
    });
  }

  setDivision(id: number): void {
    const persistFilter = JSON.parse(MasterHelper.fetchFromBrowser(this.filterPersistenceKey) as string) as RegulationFilterModel;
    if (persistFilter) {
      persistFilter.divisionId = +id;
      MasterHelper.saveOnBrowser(this.filterPersistenceKey, JSON.stringify(persistFilter));
    }
  }

  openDeleteDialog(userinfo: AssignedRoleDto): void {
    this.userInfoObj = userinfo;
    this.alertDialogModel.HeadingText = 'Delete User';
    this.alertDialogModel.BodyText = 'Are you sure you want to delete this User?';
    this.alertDialogModel.ActionButtonText = 'Delete';
    this.alertDialogModel.IsAction = true;

    const dialogRef = this.dialog.open(DeleteDialogComponent, {
      width: '450px',
      data: this.alertDialogModel
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'Delete User') {
        this.deleteUser();
      }
    });
  }

  deleteUser(): void {
    this.isLoading = true;
    if (this.userInfoObj.userId > 0) {
      this.userManagementService.deleteUserInfo(this.userInfoObj).subscribe((result: any) => {
        if (result.data) {
          if (this.isShowDivisionUser) {
            this.fetchAllUsers();
          }
          else {
            this.isShowDivisionUser = true;
            this.showDivisionWiseUser();
          }
          this.userInfoObj = new AssignedRoleDto();
        }
      });
    }
  }

  onRoleChange(item: AssignedRoleDto): AssignedRoleDto {
    item.landingPage = 0;
    this.userManagementService.getScreenByRole(item.roleId).subscribe((result: DataModel[]) => {
      item.userScreenList = result;
    });
    return item;
  }

  downloadUserReport(): any {
    this.isLoading = true;
    this.userManagementService.exportUserReport().subscribe(
      (data: any) => {
        this.isLoading = false;
        const a = document.createElement('a'),
          fileURL = URL.createObjectURL(data);
        a.href = fileURL;
        a.download = `UserInfo.csv`;
        window.document.body.appendChild(a);
        a.click();
        window.document.body.removeChild(a);
      },
      (error: HttpErrorResponse) => {
        this.isLoading = false;
        Logger.log(this.constructor.name, error.error);
      }
    );
  }

  keyPressAlphaNumeric(event: any) {
    var inp = String.fromCharCode(event.keyCode);
    if (/[a-zA-Z0-9]/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

  alertMessage(type: string, message: string): void {
    if (type === 'success') {
      this.toastModel.Title = 'Success';
      this.toastModel.Type = 'success';
    } else {
      this.toastModel.Title = 'Warning';
      this.toastModel.Type = 'warning';
    }
    this.toastModel.Message = message;
    this.isToastShow = true;
    setTimeout(() => {
      this.isToastShow = false;
    }, 3000);
  }

  showDivisionWiseUser() {
    this.isShowDivisionUser = !this.isShowDivisionUser;
    this.selectedDivisionName = this.fetchFromBrowser("selectedDivisionName");
    this.userList = [];
    this.totalCount = 0;

    this.filters.Skip = this.skipCount;
    this.filters.Take = this.takeCount;
    this.filters.SearchText = this.searchText;
    const filterItems = new UserInfoFilterModel();
    if (this.isShowDivisionUser) {
      filterItems.division = this.selectedJuris.length > 0 ? MasterHelper.getStringArrayFromObjectArray(this.selectedJuris) : [];
      this.alertDialogModel.HeadingText = 'Want to show all users?';
      this.alertDialogModel.BodyText = 'Viewing users across divisions will display details for all users regardless of divisional affiliation. Any changes made to users from other divisions may update their system access and profile. Please confirm if you would like to proceed';
      this.alertDialogModel.ActionButtonText = 'Yes';
      this.alertDialogModel.IsAction = true;
      this.alertDialogModel.cancelButtonText = 'No';

      const dialogRef = this.dialog.open(DeleteDialogComponent, {
        width: '450px',
        data: this.alertDialogModel,
      });
      dialogRef.afterClosed().subscribe((result: any) => {
        if (result === 'Want to show all users?') {
          this.isLoading = true;
          filterItems.filters = this.filters;
          this.userManagementService.getAllUsers(filterItems).subscribe((data: UserInfoData) => {
            this.isLoading = false;
            if (data.userList && data.userList.length > 0) {
              // Amit Madahar Login Permission
              if (this.loggedInUser.emailId !== 'amit.madahar@finreg-e.com') {
                for (let i = 0; i < data.userList.length; i++) {
                  if (data.userList[i].emailId === 'amit.madahar@finreg-e.com') {
                    data.userList.splice(i, 1);
                  }
                }
              }
              this.userList = data.userList;
              // Amit Madahar Login Permission
              if (this.loggedInUser.emailId !== 'amit.madahar@finreg-e.com') {
                for (let i = 0; i < this.userList.length; i++) {
                  if (this.userList[i].emailId === 'amit.madahar@finreg-e.com') {
                    this.userList.splice(i, 1);
                    data.totalCount = data.totalCount - 1;
                  }
                }
              }
              this.totalCount = this.userList.length;
              this.isTableLoaded = true;
              this.CalculatePageCount(this.totalCount, this.takeCount);
              this.lastIndex = this.skipCount + this.userList.length;
              this.startIndex = (this.takeCount * (this.currentPageNumber - 1)) + 1;
              this.endIndex = this.endIndex > this.totalCount ? this.totalCount : this.endIndex;
            }
          });
        }
        else {
          this.isShowDivisionUser = !this.isShowDivisionUser;
          this.isLoading = true;
          filterItems.division.push(this.selectedDivisionName);
          filterItems.filters = this.filters;
          this.userManagementService.getAllUsers(filterItems).subscribe((data: UserInfoData) => {
            this.isLoading = false;
            if (data.userList && data.userList.length > 0) {
              // Amit Madahar Login Permission
              if (this.loggedInUser.emailId !== 'amit.madahar@finreg-e.com') {
                for (let i = 0; i < data.userList.length; i++) {
                  if (data.userList[i].emailId === 'amit.madahar@finreg-e.com') {
                    data.userList.splice(i, 1);
                  }
                }
              }
              this.userList = data.userList;
              // Amit Madahar Login Permission
              if (this.loggedInUser.emailId !== 'amit.madahar@finreg-e.com') {
                for (let i = 0; i < this.userList.length; i++) {
                  if (this.userList[i].emailId === 'amit.madahar@finreg-e.com') {
                    this.userList.splice(i, 1);
                    data.totalCount = data.totalCount - 1;
                  }
                }
              }
              this.totalCount = this.userList.length;
              this.isTableLoaded = true;
              this.CalculatePageCount(this.totalCount, this.takeCount);
              this.lastIndex = this.skipCount + this.userList.length;
              this.startIndex = (this.takeCount * (this.currentPageNumber - 1)) + 1;
              this.endIndex = this.endIndex > this.totalCount ? this.totalCount : this.endIndex;
            }
          });
        }
      });
    }
    else {
      this.isLoading = true;
      filterItems.division.push(this.selectedDivisionName);
      filterItems.filters = this.filters;
      this.userManagementService.getAllUsers(filterItems).subscribe((data: UserInfoData) => {
        this.isLoading = false;
        if (data.userList && data.userList.length > 0) {
          // Amit Madahar Login Permission
          if (this.loggedInUser.emailId !== 'amit.madahar@finreg-e.com') {
            for (let i = 0; i < data.userList.length; i++) {
              if (data.userList[i].emailId === 'amit.madahar@finreg-e.com') {
                data.userList.splice(i, 1);
              }
            }
          }
          this.userList = data.userList;
          // Amit Madahar Login Permission
          if (this.loggedInUser.emailId !== 'amit.madahar@finreg-e.com') {
            for (let i = 0; i < this.userList.length; i++) {
              if (this.userList[i].emailId === 'amit.madahar@finreg-e.com') {
                this.userList.splice(i, 1);
                data.totalCount = data.totalCount - 1;
              }
            }
          }
          this.totalCount = this.userList.length;
          this.isTableLoaded = true;
          this.CalculatePageCount(this.totalCount, this.takeCount);
          this.lastIndex = this.skipCount + this.userList.length;
          this.startIndex = (this.takeCount * (this.currentPageNumber - 1)) + 1;
          this.endIndex = this.endIndex > this.totalCount ? this.totalCount : this.endIndex;
        }
      });
    }
  }
}
